// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb--breadcrumb--1fedo","backLink":"Breadcrumb--backLink--OBP23"};